import request from '@/utils/request'

// 上传文件
export function uploadImg(params) {
  var formData = new FormData()
  formData.append('multipartFile', params.raw)
  return request({
    url: '/v3/manager/appCenter/upload',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}